export enum EXACT_MONITORING_STORAGE_KEYS {
  ActionPreference = "exact-monitoring-action-preference",
  StatusCodePreference = "exact-monitoring-status-code-preference",
  DateFromPreference = "exact-monitoring-date-from-preference",
  DateToPreference = "exact-monitoring-date-to-preference"
}

export enum EXACT_BILLING_STORAGE_KEYS {
  FailedPreference = "exact-billing-failed-preference",
  DateFromPreference = "exact-billing-date-from-preference",
  DateToPreference = "exact-billing-date-to-preference"
}
